import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { ChevronRightIcon } from '@cognite/cogs-icons';
import { useOnKeypress } from '@cognite/cogs-utils';
import { useConfigContextLoose } from '../config-provider/config-provider.js';
import { Dropdown } from '../dropdown/dropdown.js';
import { focusForward, getSubMenuParent, isSameMenuItem, focusBackward, isItChild } from './helpers.js';
import { MenuItem } from './menu-item.js';
import { useMouseMove } from './use-mouse-move.js';

var MenuSubmenu = function MenuSubmenu(_a) {
  var _b;
  var children = _a.children,
    icon = _a.icon,
    disabled = _a.disabled,
    appendTo = _a.appendTo,
    openOnHover = _a.openOnHover,
    submenuTooltipProps = _a.submenuTooltipProps,
    toggleActiveParent = _a.toggleActiveParent,
    onClick = _a.onClick,
    otherProps = __rest(_a, ["children", "icon", "disabled", "appendTo", "openOnHover", "submenuTooltipProps", "toggleActiveParent", "onClick"]);
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  var _useState2 = useState(null),
    dropdownRef = _useState2[0],
    setDropdownRef = _useState2[1];
  var appendToLocal = (_b = appendTo !== null && appendTo !== undefined ? appendTo : getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer()) !== null && _b !== undefined ? _b : 'parent';
  var mouseMoveCb = function mouseMoveCb(e) {
    if (!dropdownRef) return;
    if (e.type === 'mouseout' || e.type === 'mouseleave') {
      var relatedTarget = e.relatedTarget;
      if (relatedTarget) {
        var result = isItChild(relatedTarget, dropdownRef);
        if (!result) {
          setVisible(false);
        }
      }
    }
    if ((e.type === 'mouseover' || e.type === 'mouseenter') && !visible) {
      setVisible(true);
    }
  };
  useMouseMove(mouseMoveCb, dropdownRef);
  // kyeboard navigation of the submenu
  var keypressCb = function keypressCb(e) {
    var target = e.target;
    if (dropdownRef) {
      if (e.key === 'ArrowRight' || e.key === 'Enter' || e.code === 'Space') {
        setVisible(true);
        focusForward(dropdownRef, target);
        toggleActiveParent === null || toggleActiveParent === undefined ? undefined : toggleActiveParent(false);
      }
      if (e.key === 'ArrowLeft') {
        // element that we press arrowLeft from. element that triggers the event.
        // exact parent of the element this event got emit.
        var relevantParent = getSubMenuParent(target);
        // check if the event triggerer and menu parent is same
        if (isSameMenuItem(relevantParent, dropdownRef)) {
          setVisible(false);
          if (relevantParent) {
            toggleActiveParent === null || toggleActiveParent === undefined ? undefined : toggleActiveParent(true);
            focusBackward(relevantParent);
          }
        }
      }
    }
  };
  useOnKeypress(keypressCb, dropdownRef);
  // close the submenu whenever we click outside
  var onClickOutside = function onClickOutside() {
    setVisible(false);
    toggleActiveParent === null || toggleActiveParent === undefined ? undefined : toggleActiveParent(true);
  };
  var hideHandle = function hideHandle() {
    toggleActiveParent === null || toggleActiveParent === undefined ? undefined : toggleActiveParent(true);
  };
  return jsx("div", {
    className: "submenu-wrapper",
    ref: setDropdownRef,
    children: jsx(Dropdown, Object.assign({
      placement: "right-start",
      trigger: "mouseenter focus focusin click",
      hideOnClick: false,
      appendTo: appendToLocal,
      openOnHover: openOnHover,
      onHide: hideHandle,
      disabled: disabled,
      visible: visible,
      onClickOutside: onClickOutside
    }, otherProps, {
      children: jsx(MenuItem, {
        menuItemTooltipProps: submenuTooltipProps,
        icon: icon,
        disabled: disabled,
        iconPlacement: "right",
        submenuIcon: jsx(ChevronRightIcon, {}),
        onClick: onClick,
        children: children
      })
    }))
  });
};

export { MenuSubmenu };
